class AbbinaBundle extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerElement = document.querySelector('cart-drawer');
    this.addToCartButtonElement = this.querySelector('[data-abbina-add-all]');
    this.errorMessageElement = this.querySelector('.product-form__error-message');

    this.addToCartButtonElement &&
      this.addToCartButtonElement.addEventListener('click', this.handleButtonClick.bind(this));
  }

  getItems() {
    const rows = this.querySelectorAll('[data-bundle-item]');
    return [...rows]
      .map((row) => {
        const idField = row.querySelector('[name="id"]');
        const qtyField = row.querySelector('[name="quantity"]');
        if (!idField || !idField.value) return null;
        const quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
        return { id: idField.value, quantity };
      })
      .filter(Boolean);
  }

  handleButtonClick(event) {
    event.preventDefault();
    this.lastClickedElement = event.currentTarget;

    const items = { items: this.getItems() };
    if (!items.items.length) return;

    if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType != 'drawer') {
      FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { ...items } });
      return;
    }

    this.showErrorMessage();
    this.toggleButtonLoading(true);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({
      ...items,
      sections: sectionsToBundle,
      section_url: window.pathname,
    });

    fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          this.showErrorMessage(parsedState.description);
          return;
        }

        const cartJson = await (
          await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })
        ).json();
        cartJson['sections'] = parsedState['sections'];

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            detail: { product: parsedState },
          })
        );
        this.cartDrawerElement && this.cartDrawerElement.show(this.lastClickedElement);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.toggleButtonLoading(false);
      });
  }

  showErrorMessage(errorMessage = false) {
    this.errorMessageElement = this.errorMessageElement || this.querySelector('.product-form__error-message');
    if (this.errorMessageElement) {
      this.errorMessageElement.hidden = !errorMessage;
      if (errorMessage) this.errorMessageElement.textContent = errorMessage;
    } else {
      errorMessage && alert(errorMessage);
    }
  }

  toggleButtonLoading(status) {
    if (status) {
      this.addToCartButtonElement.classList.add('btn--loading');
      this.addToCartButtonElement.setAttribute('disabled', true);
    } else {
      this.addToCartButtonElement.classList.remove('btn--loading');
      this.addToCartButtonElement.removeAttribute('disabled');
    }
  }
}
customElements.define('abbina-bundle', AbbinaBundle);
